export default "__VITE_ASSET__CFU4DENT__"